<script setup lang="ts">
const { $gsap } = useNuxtApp()

const $title = useTemplateRef('$title')

onMounted(() => {
  $gsap.set($title.value, { yPercent: 100 })

  if (import.meta.server) return

  $gsap.to($title.value, {
    scrollTrigger: {
      trigger: $title.value,
      end: 'center center',
      // markers: config.SCROLLTRIGGER_MARKERS_ENABLED === 'true' && import.meta.dev,
      scrub: true,
    },
    yPercent: 0,
  })
})
</script>

<template>
  <div>
    <div class="flex h-[150vh] items-center justify-center">
      <h1 class="font-mono text-3xl text-zinc-600 uppercase">Pre</h1>
    </div>

    <InfiniteScrollNavigationLink :href="'/about'">
      <article
        class="flex h-[140vh] items-center justify-center bg-gradient-to-br from-amber-200 to-orange-300"
      >
        <h1
          class="w-full overflow-clip border-y text-center font-mono text-7xl text-white uppercase"
        >
          <span ref="$title" class="inline-block">Element</span>
        </h1>
      </article>
    </InfiniteScrollNavigationLink>

    <div class="flex h-[75vh] items-center justify-center">
      <h1 class="font-mono text-3xl text-zinc-600 uppercase">Post</h1>
    </div>
  </div>
</template>
